import * as tslib_1 from "tslib";
/* tslint:disable:cyclomatic-complexity */
import { ElementRef, EventEmitter, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { util } from '../../../classes/util';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { isClassBreaksRenderer, isHeatmapRenderer, isTextSymbol, isUniqueValueRenderer } from '../../../types';
import { BaseComponent } from '../../base.component';
var Graphic;
var LegendSymbolComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LegendSymbolComponent, _super);
    function LegendSymbolComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.showAllSymbols = false;
        _this.onsymbolchange = new EventEmitter();
        _this.creatingColorRampSymbol = false;
        _this.symbolIsColorRamp = false;
        /**
         * Handles the global symbolChange event which is fired when the
         * symbol-editor component changes the symbol for a layer.
         */
        _this.onWindowSymbolChange = function (event) {
            if (event.detail === _this.uniqueLayerId) {
                _this.refreshPreview();
                _this.layerService.layersRefreshed.emit();
            }
        };
        _this.registerEvent('onsymbolchange', _this.onsymbolchange);
        _this.refreshPreview = util.debounce(_this.refreshPreviewWork.bind(_this), 50);
        return _this;
    }
    Object.defineProperty(LegendSymbolComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LegendSymbolComponent.prototype, "uniqueLayerId", {
        get: function () {
            return this._uniqueLayerId;
        },
        set: function (val) {
            this._uniqueLayerId = val;
            this.esriLayer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
            this.refreshPreview();
        },
        enumerable: true,
        configurable: true
    });
    LegendSymbolComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.Graphic])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), Graphic = _a[0];
                        window.addEventListener('symbolChange', this.onWindowSymbolChange);
                        return [2 /*return*/];
                }
            });
        });
    };
    LegendSymbolComponent.prototype.ngOnDestroy = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                window.removeEventListener('symbolChange', this.onWindowSymbolChange);
                return [2 /*return*/];
            });
        });
    };
    LegendSymbolComponent.prototype.refreshPreviewWork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, e_3, _c, symbolUtil, esriLayer, graphicsSymbol, renderers, _d, _e, child, renderers_1, renderers_1_1, renderer, _f, colors, symbols, colorRamp, symbols_1, symbols_1_1, symbol, previewHTML, e_3_1, heatmapColors, heatmapColorRamp, e_2_1, er_1;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, ESRI.SymbolUtils];
                    case 1:
                        symbolUtil = _g.sent();
                        esriLayer = this.esriLayer;
                        if (!esriLayer) return [3 /*break*/, 35];
                        if (!!esriLayer.loaded) return [3 /*break*/, 3];
                        return [4 /*yield*/, esriLayer.when()];
                    case 2:
                        _g.sent();
                        _g.label = 3;
                    case 3:
                        graphicsSymbol = this.setupGraphicsSymbol(esriLayer);
                        return [4 /*yield*/, this.setupRenderers(esriLayer)];
                    case 4:
                        renderers = _g.sent();
                        if (this.legendSymbol.nativeElement.childNodes.length) {
                            try {
                                for (_d = tslib_1.__values(Array.from(this.legendSymbol.nativeElement.childNodes)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                    child = _e.value;
                                    this.legendSymbol.nativeElement.removeChild(child);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        if (!renderers.length) return [3 /*break*/, 31];
                        _g.label = 5;
                    case 5:
                        _g.trys.push([5, 28, 29, 30]);
                        renderers_1 = tslib_1.__values(renderers), renderers_1_1 = renderers_1.next();
                        _g.label = 6;
                    case 6:
                        if (!!renderers_1_1.done) return [3 /*break*/, 27];
                        renderer = renderers_1_1.value;
                        if (renderer.symbol && renderer.symbol.color && renderer.symbol.color.a) {
                            renderer.symbol.color.a *= esriLayer.opacity;
                        }
                        if (renderer.symbol && renderer.symbol.outline) {
                            renderer.symbol.outline.color.a *= esriLayer.opacity;
                        }
                        if (!(isClassBreaksRenderer(renderer) || isUniqueValueRenderer(renderer))) return [3 /*break*/, 22];
                        _f = tslib_1.__read(this.getColorsOrSymbols(renderer), 2), colors = _f[0], symbols = _f[1];
                        if (!colors.length) return [3 /*break*/, 11];
                        if (!(colors.length === 1)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.renderSymbolPreview(isClassBreaksRenderer(renderer) ? renderer.classBreakInfos[0].symbol : renderer.uniqueValueInfos[0].symbol)];
                    case 7:
                        _g.sent();
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, symbolUtil.renderColorRampPreviewHTML(colors, { gradient: renderer.type === 'class-breaks' ? true : false, height: 24, width: 24 })];
                    case 9:
                        colorRamp = _g.sent();
                        if (this.legendSymbol.nativeElement.childNodes.length < 1) {
                            this.legendSymbol.nativeElement.appendChild(colorRamp);
                        }
                        this.symbolIsColorRamp = true;
                        _g.label = 10;
                    case 10: return [3 /*break*/, 21];
                    case 11:
                        if (!symbols.length) return [3 /*break*/, 21];
                        if (!(symbols.length === 1)) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.renderSymbolPreview(symbols[0])];
                    case 12:
                        _g.sent();
                        return [3 /*break*/, 21];
                    case 13:
                        this.symbolIsColorRamp = false;
                        _g.label = 14;
                    case 14:
                        _g.trys.push([14, 19, 20, 21]);
                        symbols_1 = tslib_1.__values(symbols), symbols_1_1 = symbols_1.next();
                        _g.label = 15;
                    case 15:
                        if (!!symbols_1_1.done) return [3 /*break*/, 18];
                        symbol = symbols_1_1.value;
                        return [4 /*yield*/, symbolUtil.renderPreviewHTML(symbol, { maxSize: 14, scale: true, size: { width: 29 } })];
                    case 16:
                        previewHTML = _g.sent();
                        this.legendSymbol.nativeElement.appendChild(previewHTML);
                        _g.label = 17;
                    case 17:
                        symbols_1_1 = symbols_1.next();
                        return [3 /*break*/, 15];
                    case 18: return [3 /*break*/, 21];
                    case 19:
                        e_3_1 = _g.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 21];
                    case 20:
                        try {
                            if (symbols_1_1 && !symbols_1_1.done && (_c = symbols_1.return)) _c.call(symbols_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 21: return [3 /*break*/, 27];
                    case 22:
                        if (!isHeatmapRenderer(renderer)) return [3 /*break*/, 24];
                        heatmapColors = renderer.colorStops.map(function (x) { return x.color; }).slice(1);
                        return [4 /*yield*/, symbolUtil.renderColorRampPreviewHTML(heatmapColors, { align: 'horizontal', gradient: true, height: 24, width: 24 })];
                    case 23:
                        heatmapColorRamp = _g.sent();
                        if (this.legendSymbol.nativeElement.childNodes.length < 1) {
                            this.legendSymbol.nativeElement.appendChild(heatmapColorRamp);
                        }
                        this.symbolIsColorRamp = true;
                        return [3 /*break*/, 27];
                    case 24: return [4 /*yield*/, this.renderSymbolPreview(renderer.symbol)];
                    case 25:
                        _g.sent();
                        _g.label = 26;
                    case 26:
                        renderers_1_1 = renderers_1.next();
                        return [3 /*break*/, 6];
                    case 27: return [3 /*break*/, 30];
                    case 28:
                        e_2_1 = _g.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 30];
                    case 29:
                        try {
                            if (renderers_1_1 && !renderers_1_1.done && (_b = renderers_1.return)) _b.call(renderers_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 30: return [3 /*break*/, 35];
                    case 31:
                        if (!graphicsSymbol) return [3 /*break*/, 35];
                        if (isTextSymbol(graphicsSymbol)) {
                            graphicsSymbol = graphicsSymbol.clone();
                            graphicsSymbol.text = 'Text';
                        }
                        if (graphicsSymbol.color && graphicsSymbol.color.a) {
                            graphicsSymbol.color.a *= esriLayer.opacity;
                        }
                        if (graphicsSymbol.outline) {
                            graphicsSymbol.outline.color.a *= esriLayer.opacity;
                        }
                        this.symbolIsColorRamp = false;
                        _g.label = 32;
                    case 32:
                        _g.trys.push([32, 34, , 35]);
                        return [4 /*yield*/, symbolUtil.renderPreviewHTML(graphicsSymbol, { maxSize: 12, scale: true, node: this.legendSymbol.nativeElement, size: { width: 29 } })];
                    case 33:
                        _g.sent();
                        return [3 /*break*/, 35];
                    case 34:
                        er_1 = _g.sent();
                        return [3 /*break*/, 35];
                    case 35: return [2 /*return*/];
                }
            });
        });
    };
    LegendSymbolComponent.prototype.renderSymbolPreview = function (symbol) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var symbolUtil;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.SymbolUtils];
                    case 1:
                        symbolUtil = _a.sent();
                        this.symbolIsColorRamp = false;
                        if (symbol.type === 'picture-marker') {
                            this.layerService.fixPictureSymbols([symbol]);
                        }
                        return [4 /*yield*/, symbolUtil.renderPreviewHTML(symbol, { maxSize: 14, scale: true, node: this.legendSymbol.nativeElement, size: { width: 29 } })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LegendSymbolComponent.prototype.getColorsOrSymbols = function (renderer) {
        var e_4, _a, e_5, _b;
        var colors = [];
        var symbols = [];
        if (isClassBreaksRenderer(renderer)) {
            try {
                for (var _c = tslib_1.__values(renderer.classBreakInfos), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var classBreak = _d.value;
                    colors.push(classBreak.symbol.color);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        else if (isUniqueValueRenderer(renderer)) {
            var max = renderer.defaultSymbol ? 1 : 2;
            if (renderer.defaultSymbol) {
                if (renderer.defaultSymbol.color) {
                    colors.push(renderer.defaultSymbol.color);
                }
                else {
                    symbols.push(renderer.defaultSymbol);
                }
            }
            try {
                for (var _e = tslib_1.__values(renderer.uniqueValueInfos), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var classBreak = _f.value;
                    if (classBreak.symbol) {
                        if (classBreak.symbol.color) {
                            colors.push(classBreak.symbol.color);
                        }
                        else {
                            symbols.push(classBreak.symbol);
                            if (!this.showAllSymbols && symbols.length >= max) {
                                break;
                            }
                        }
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        return [colors.filter(function (c) { return c; }), symbols];
    };
    LegendSymbolComponent.prototype.setupRenderers = function (esriLayer) {
        var e_6, _a;
        var renderers = [];
        if (esriLayer.type === 'map-image') {
            try {
                for (var _b = tslib_1.__values(esriLayer.sublayers.toArray()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var sublayer = _c.value;
                    if (sublayer.renderer) {
                        renderers.push(util.deepClone(sublayer.renderer));
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        else if (esriLayer.type !== 'graphics' && esriLayer.renderer) {
            renderers.push(util.deepClone(esriLayer.renderer));
        }
        return renderers;
    };
    LegendSymbolComponent.prototype.setupGraphicsSymbol = function (esriLayer) {
        var graphicsSymbol;
        if (esriLayer.type === 'graphics') {
            graphicsSymbol = util.deepClone(this.getSymbolForGraphicsLayer(esriLayer));
        }
        return graphicsSymbol;
    };
    // Note: The ESRI watch does not seem to be working below. The watch only triggers on certain object properties.
    // Assume ESRI will fix in the future.
    LegendSymbolComponent.prototype.setRendererWatch = function () {
        var _this = this;
        var e_7, _a;
        var watchValues = null;
        if (this.esriLayer) {
            if (this.esriLayer.type === 'map-image') {
                try {
                    for (var _b = tslib_1.__values(this.esriLayer.sublayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var sublayer = _c.value;
                        sublayer.watch('renderer, renderer.type, renderer.symbol, renderer.symbol.color, renderer.symbol.outline, renderer.symbol.outline.color, renderer.uniqueValueInfos', function () {
                            _this.refreshPreview();
                        });
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            }
            else if (this.esriLayer.type === 'graphics') {
                var symbol = this.getSymbolForGraphicsLayer(this.esriLayer);
                if (symbol) {
                    watchValues = 'graphics';
                }
            }
            else {
                if ('renderer' in this.esriLayer) {
                    if (this.esriLayer.renderer && this.esriLayer.renderer.symbol) {
                        watchValues = 'renderer, renderer.type, renderer.symbol, renderer.symbol.color, renderer.symbol.outline, renderer.symbol.outline.color';
                    }
                    else if (this.esriLayer.renderer && this.esriLayer.renderer.type === 'heatmap') {
                        watchValues = 'renderer, renderer.type, renderer.blurRadius, renderer.colorStops, renderer.colorStops[1].color, renderer.colorStops[2].color';
                    }
                }
            }
            if (watchValues) {
                this.esriLayer.watch(watchValues, function () {
                    _this.refreshPreview();
                });
            }
        }
    };
    LegendSymbolComponent.prototype.changeSymbol = function () {
        if (this.symbolIsColorRamp) {
            this.onsymbolchange.emit({ symbolIsColorRamp: true, uniqueLayerId: this.uniqueLayerId });
        }
        else {
            this.onsymbolchange.emit({ symbolIsColorRamp: false, uniqueLayerId: this.uniqueLayerId });
        }
    };
    LegendSymbolComponent.prototype.whichChild = function (target) {
        var element = target;
        var divParent = null;
        while (divParent === null) {
            if (element.tagName === 'DIV') {
                divParent = element;
            }
            else {
                element = element.parentElement;
            }
        }
        var i = 0;
        while (element.previousSibling !== null) {
            element = element.previousSibling;
            i += 1;
        }
        return i;
    };
    LegendSymbolComponent.prototype.getSymbolForGraphicsLayer = function (esriLayer) {
        if (esriLayer.mapcoreProps && esriLayer.mapcoreProps.symbol) {
            var graphic = new Graphic({ symbol: JSON.parse(esriLayer.mapcoreProps.symbol) });
            return graphic.symbol;
        }
        else {
            return this.getSymbolFromGraphics(esriLayer.graphics);
        }
    };
    LegendSymbolComponent.prototype.getSymbolFromGraphics = function (graphics) {
        var retVal = null;
        if (graphics && graphics.length) {
            retVal = graphics.getItemAt(graphics.length - 1).symbol;
        }
        return retVal;
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LegendSymbolComponent.prototype, "showAllSymbols", void 0);
    return LegendSymbolComponent;
}(BaseComponent));
export { LegendSymbolComponent };
